var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 2V5H7.11111C5.4 5 4 6.35 4 8V29C4 30.65 5.4 32 7.11111 32H28.8889C30.6 32 32 30.65 32 29V8C32 6.35 30.6 5 28.8889 5H27.3333V2H24.2222V5H11.7778V2H8.66667ZM7.11111 8H8.66667H11.7778H24.2222H27.3333H28.8889V11H7.11111V8ZM7.11111 14H28.8889V29H7.11111V14Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b138cb356cf575647c2ecf42dfa698ba.svg";
export { ForwardRef as ReactComponent };